import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { guid } from '@antv/l7-utils';
import { EventEmitter } from 'eventemitter3';
export default class DebugService extends EventEmitter {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderMap", new Map());
    _defineProperty(this, "enable", false);
    _defineProperty(this, "renderEnable", false);
    _defineProperty(this, "cacheLogs", {});
  }
  setEnable(flag) {
    this.enable = !!flag;
  }
  log(key, values) {
    if (!this.enable) {
      return;
    }
    const keys = key.split('.'); // [12, init, layerInitStart]
    let parent = null;
    keys.forEach((k, i) => {
      if (parent !== null) {
        if (!parent[k]) {
          parent[k] = {};
        }
        if (i !== keys.length - 1) {
          parent = parent[k];
        }
      } else {
        if (!this.cacheLogs[k]) {
          this.cacheLogs[k] = {};
        }
        if (i !== keys.length - 1) {
          parent = this.cacheLogs[k];
        }
      }
      if (i === keys.length - 1) {
        parent[k] = _objectSpread(_objectSpread({
          time: Date.now()
        }, parent[k]), values);
      }
    });
  }
  getLog(key) {
    switch (typeof key) {
      case 'string':
        return this.cacheLogs[key];
      case 'object':
        return key.map(k => this.cacheLogs[k]).filter(o => o !== undefined);
      case 'undefined':
        return this.cacheLogs;
    }
  }

  /**
   * 删除日志
   * @param key
   */
  removeLog(key) {
    delete this.cacheLogs[key];
  }
  generateRenderUid() {
    if (this.renderEnable) {
      return guid();
    } else {
      return '';
    }
  }
  renderDebug(enable) {
    this.renderEnable = enable;
  }
  renderStart(id) {
    if (!this.renderEnable || !this.enable) {
      return;
    }
    const cacheRenderInfo = this.renderMap.get(id) || {};
    this.renderMap.set(id, _objectSpread(_objectSpread({}, cacheRenderInfo), {}, {
      renderUid: id,
      renderStart: Date.now()
    }));
  }
  renderEnd(id) {
    if (!this.renderEnable || !this.enable) {
      return;
    }
    const cacheRenderInfo = this.renderMap.get(id);
    if (cacheRenderInfo) {
      const renderStart = cacheRenderInfo.renderStart;
      const renderEnd = Date.now();
      this.emit('renderEnd', _objectSpread(_objectSpread({}, cacheRenderInfo), {}, {
        renderEnd,
        renderDuration: renderEnd - renderStart
      }));
      this.renderMap.delete(id);
    }
  }
  destroy() {
    this.cacheLogs = null;
    this.renderMap.clear();
  }
}